import {
  LARGE_THUMBNAIL_DIMENSIONS,
  THUMBNAIL_DIMENSIONS,
} from "@shared/constants/fileDimensions";

/** Mirrors oem's `DEFAULT_PART_IMAGE_SRC`; the asset is served by both apps. */
const DEFAULT_PART_IMAGE_SRC = "/images/default/parts-thumbnail.svg";

/**
 * Thumbnail URL for an inventory part, falling back to the placeholder image.
 * Ported from oem's `~/utils/_parts` so @shared/ui's PartRow carries no oem
 * dependency. oem re-exports it.
 */
export const getPartThumbnail = (
  part?: { image?: string | null } | null,
  isPreview = false,
): string => {
  const thumbnailDimensions = isPreview
    ? LARGE_THUMBNAIL_DIMENSIONS
    : THUMBNAIL_DIMENSIONS;
  if (part?.image) {
    return part.image.includes("http")
      ? `${part.image}${thumbnailDimensions}`
      : `${part.image}`;
  }
  return DEFAULT_PART_IMAGE_SRC;
};
